<template>
  <div class="whole">
    <m-header></m-header>
    <m-sidebar></m-sidebar>
    <div class="data-content">
      <div class="userOperate">
        <el-button @click="handleAdd">新增商品</el-button>
        <el-pagination background layout="prev, pager, next" :current-page="pageNum" @current-change="pageChange"
          :total="totalNum" v-if="paginationShow">
        </el-pagination>
      </div>
      <div class="userTable">
        <el-table ref="multipleTable" :data="productDatas" tooltip-effect="dark" style="width: 100%" border
          @selection-change="handleSelectionChange">
          <el-table-column type="selection" width="60">
          </el-table-column>
          <el-table-column prop="name" label="门店名称" width="150">
          </el-table-column>
          <el-table-column prop="title" label="商品名" width="600">
          </el-table-column>
          <el-table-column prop="specialSpec" label="商品规格" width="200">
          </el-table-column>
          <el-table-column prop="num" label="库存数量" width="100">
          </el-table-column>
          <!-- <el-table-column label="操作" show-overflow-tooltip>
            <template slot-scope="scope">
              <el-button size="mini" @click="handleUpdate(scope.row, 1)">修改</el-button>
            </template>
          </el-table-column> -->
        </el-table>
      </div>
      <el-dialog title="添加门店商品" :visible.sync="addDialogVisible" width="40%" center :append-to-body=true>
        <el-form :label-position="left" label-width="100px" ref="addForm">
          <el-form-item label="选择门店">
            <el-select v-model="storeId" style="width: 300px;">
              <el-option v-for="item in allStoreDatas" :key="item.id" :label="item.name"
                :value="item.id" />
            </el-select>
          </el-form-item>
          <el-form-item label="选择商品">
            <el-select v-model="addSpuIds" style="width: 300px;">
              <el-option v-for="item in allProductDatas" :key="item.id" :label="item.title+item.specialSpec"
                :value="item.id" />
            </el-select>
          </el-form-item>
          <el-form-item label="库存数量">
            <el-input v-model="num"></el-input>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="addDialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="_addDirectSell()">确 定</el-button>
        </span>
      </el-dialog>
      <el-dialog title="提示" :visible.sync="deleteDialogVisible" width="20%" :append-to-body=true center>
        <span>确定要从厂家直销中移除选择的商品吗？</span>
        <span slot="footer" class="dialog-footer">
          <el-button @click="deleteDialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="_deleteDirectSell()">确 定</el-button>
        </span>
      </el-dialog>
    </div>
  </div>
</template>

<script>
  import {
    Loading
  } from 'element-ui'
  import MSidebar from 'components/header/sidebar'
  import MHeader from 'components/header/header'
  import {
    addStoreWarehouse,
    getAllDirectSell,
    getCategorys,
    getAllSupplier,
    getLogistics,
    getAllProduct,
    productSkuList,
    addDirectSell,
    modifyStatus,
    deleteDirectSell,
    uploadFile1,
    getStoreAllProduct,
    getStoreAuditList
  } from 'api/request'
  import {
    ERR_OK
  } from 'api/config'
  import {
    formatDate,
    loadingInstance,
    Success,
    Error
  } from 'common/js/util'
  export default {
    components: {
      MSidebar,
      MHeader
    },
    data() {
      return {
        token: window.localStorage.getItem("token"),
        pageSize: 10,
        pageNum: 1,
        totalNum: 0,
        paginationShow: false,
        ca: null,
        spuIds: [],
        addSpuIds: [],
        storeId: null,
        supplierOptions: [],
        categoryOptions: [],
        logisticsOptions: [],
        supplierId: null,
        categoryId: null,
        keywords: null,
        addDialogVisible: false,
        deleteDialogVisible: false,
        detailDialogVisible: false,
        left: "left",
        addData: {},
        controlData: {},
        roundDatas: [],
        productDatas: [],
        allProductDatas: [],
        allStoreDatas: [],
        multipleSelection: [],
        fileList: [],
        fileList1: [],
        fileyHeader: {},
        fileData: {
          type: 1
        },
        addData: {
          name: "",
          price: "",
          score: "",
          mainPicture: "",
          detailPicture: []
        },
        num: 0
      }
    },
    mounted() {
      let getUserInfo = JSON.parse(window.localStorage.getItem('getUserInfo'));
      if (!getUserInfo) {
        this.$router.push({
          path: '/'
        })
      } else {
      this.fileyHeader = {
        token: getUserInfo.token,
        'Content-Type': 'application/json;charset=utf-8'
      }
      this._getList();
      /* this._getCategory();
       this._getSupplier();
       this._getLogistics(); */
      this._getProductList();
      this._getStoreAuditList();
    }
  },
  methods: {
    toggleSelection(rows) {
      if (rows) {
        rows.forEach(row => {
          this.$refs.multipleTable.toggleRowSelection(row);
        });
      } else {
        this.$refs.multipleTable.clearSelection();
      }
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
      this.spuIds = [];
      for (let i = 0; i < this.multipleSelection.length; i++) {
        this.spuIds.push(this.multipleSelection[i].id);
      }
      console.log(this.spuIds);
    },
    pageChange(val) {
      console.log(val)
      this.pageNum = val
      this._getList()
    },
    uploadSectionFile(param) {
      var fileObj = param.file;
      var form = new FormData();
      form.append("file", fileObj);
      form.append("type", 101);

      uploadFile1(form).then((res) => {
        loadingInstance(Loading).close()
        if (res.status === ERR_OK) {
          this.addData.mainPicture = res.data;
        } else {
          Error(this, res)
        }
      })
    },
    uploadSectionFile1(param) {
      var fileObj = param.file;
      var form = new FormData();
      form.append("file", fileObj);
      form.append("type", 101);

      uploadFile1(form).then((res) => {
        loadingInstance(Loading).close()
        if (res.status === ERR_OK) {
          this.addData.detailPicture.push(res.data);
        } else {
          Error(this, res)
        }
      })
    },
    handleStatusValue(row, column, cellValue, index) {
      //商品状态  1正常    0.下架
      switch (cellValue) {
        case 0:
          return "下架";
        case 1:
          return "在售";
      }
    },
    handleAdd() {
      this.addDialogVisible = true;
    },
    handleDelete(index, row) {
      this.deleteDialogVisible = true;
      this.spuIds = [row.id];
    },
    handleManyDelete() {
      this.deleteDialogVisible = true;
    },
    handleStatus(data, status) {
      let param = {
        id: data.id,
        state: status
      }
      loadingInstance(Loading);
      modifyStatus(param).then((res) => {
        loadingInstance(Loading).close()
        if (res.status === ERR_OK) {
          Success(this, res);
          this._getList();
        } else {
          Error(this, res);
        }
      });
    },
    handleEdit(index, row) {
      window.localStorage.setItem('productId', row.id);
      this.$router.push({
        path: '/addProduct'
      })
    },
    handleRemove(file, fileList) {
      console.log(file, fileList);
    },
    handleRemove1(file, fileList) {
      console.log(file, fileList);
    },
    handlePreview(file) {
      console.log(file);
    },
    _addDirectSell() {
      let param = {
        skuId: this.addSpuIds,
        num: this.num,
        storeId: this.storeId,
      }
      loadingInstance(Loading);
      addStoreWarehouse(param).then((res) => {
        loadingInstance(Loading).close()
        if (res.status === ERR_OK) {
          this.addDialogVisible = false;
          this.addSpuIds = [];
          this._getList();
        } else {
          Error(this, res);
        }
      })
    },
    _deleteDirectSell() {
      let param = {
        spuIds: this.spuIds
      }
      loadingInstance(Loading);
      deleteDirectSell(param).then((res) => {
        loadingInstance(Loading).close()
        if (res.status === ERR_OK) {
          this.deleteDialogVisible = false;
          this._getList();
        } else {
          Error(this, res);
        }
      })
    },
    _getCategory() {
      let param = {}
      loadingInstance(Loading)
      getCategorys(param).then((res) => {
        loadingInstance(Loading).close()
        if (res.status === ERR_OK) {
          if (res.data.length > 0) {
            //处理分类结构
            this.categoryOptions = [];
            for (var i = 0; i < res.data.length; i++) {
              let cate = res.data[i];
              let category = {};
              category.value = cate.id;
              category.label = cate.name;
              if (cate.categoryVos != null) {
                let child = [];
                for (var j = 0; j < cate.categoryVos.length; j++) {
                  let cc = {};
                  cc.value = cate.categoryVos[j].id;
                  cc.label = cate.categoryVos[j].name;
                  child.push(cc);
                }
                category.children = child;
              }
              this.categoryOptions.push(category);
            }
          }
        } else {
          Error(this, res)
        }
      })
    },
    _getSupplier() {
      let param = {}
      loadingInstance(Loading)
      getAllSupplier(param).then((res) => {
        loadingInstance(Loading).close()
        if (res.status === ERR_OK) {
          this.supplierOptions = res.data.records
        } else {
          Error(this, res)
        }
      })
    },
    _getLogistics() {
      let param = {
        current: this.pageNum,
        size: 100
      }
      loadingInstance(Loading)
      getAllSupplier(param).then((res) => {
        loadingInstance(Loading).close()
        if (res.status === ERR_OK) {
          this.logisticsOptions = res.data.records
        } else {
          Error(this, res)
        }
      })
    },
    _getProductList() {
      loadingInstance(Loading)
      productSkuList().then((res) => {
        loadingInstance(Loading).close()
        if (res.status === ERR_OK) {
          this.allProductDatas = res.data
        } else {
          Error(this, res)
        }
      })
    },
    _getStoreAuditList() {
      loadingInstance(Loading)

      getStoreAuditList().then((res) => {
        loadingInstance(Loading).close()
        if (res.status === ERR_OK) {
          this.allStoreDatas = res.data.records
        } else {
          Error(this, res)
        }
      })
    },
    _getList() {
      let param = {
        current: this.pageNum,
        size: this.pageSize
      }
      loadingInstance(Loading)
      getStoreAllProduct(param).then((res) => {
        loadingInstance(Loading).close()
        if (res.status === ERR_OK) {
          this.productDatas = res.data.records
          this.totalNum = res.data.total
          if (res.data.pages > 1) {
            this.paginationShow = true;
          }
        } else {
          Error(this, res)
        }
      })
    }
  },
  }
</script>
<style scoped>
  .user {
    z-index: 9;
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    background-color: #F8F8F8;
  }

  .userOperate {
    height: 50px;
    margin-left: 10px;
    margin-right: 10px;
    margin-top: 30px;
    margin-bottom: 10px;
    box-sizing: border-box;
  }

  .userTable {
    padding: 10px;
    position: relative;
  }
</style>
<style>
  .userOperate .el-input {
    width: 180px;
    margin-right: 10px;
    display: inline-block;
    float: left;
  }

  .userOperate .el-button {
    width: 100px;
    display: inline-block;
    float: left;
    margin-right: 40px;
  }
</style>



// WEBPACK FOOTER //
// src/components/product/storeProduct.vue